import React, { useState, useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Cookie, X, ChevronRight } from "lucide-react";
import { useNavigate } from "react-router-dom";

const CookieBanner = () => {
  const [visible, setVisible] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const consent = localStorage.getItem("cookie_consent");
    if (!consent) {
      const timer = setTimeout(() => setVisible(true), 1500);
      return () => clearTimeout(timer);
    }
  }, []);

  // Erneutes Öffnen über den "Cookie-Einstellungen"-Link (Widerruf/Änderung)
  useEffect(() => {
    const open = () => setVisible(true);
    window.addEventListener("open-cookie-settings", open);
    return () => window.removeEventListener("open-cookie-settings", open);
  }, []);

  const acceptAll = () => {
    localStorage.setItem("cookie_consent", "all");
    // Analytics (PostHog) erst jetzt – nach ausdrücklicher Einwilligung – starten
    if (typeof window.enableAnalytics === "function") window.enableAnalytics();
    setVisible(false);
  };

  const acceptEssential = () => {
    localStorage.setItem("cookie_consent", "essential");
    // Falls Analytics zuvor aktiv war: Tracking stoppen (Widerruf der Einwilligung)
    try {
      if (window.posthog && window.__analyticsLoaded) window.posthog.opt_out_capturing();
    } catch (e) {}
    setVisible(false);
  };

  return (
    <AnimatePresence>
      {visible && (
        <motion.div
          initial={{ y: 100, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          exit={{ y: 100, opacity: 0 }}
          transition={{ duration: 0.5, ease: "easeOut" }}
          className="fixed bottom-0 left-0 right-0 z-[70] p-4 md:p-6"
        >
          <div className="max-w-[720px] mx-auto bg-white rounded-2xl shadow-2xl shadow-black/10 border border-[#e5e5e5] overflow-hidden">
            <div className="p-6">
              {/* Header */}
              <div className="flex items-start justify-between mb-4">
                <div className="flex items-center gap-3">
                  <div className="w-10 h-10 rounded-xl bg-[#4a7c59]/10 flex items-center justify-center flex-shrink-0">
                    <Cookie size={20} className="text-[#4a7c59]" />
                  </div>
                  <div>
                    <h3 className="text-base font-semibold text-[#1d1d1f]">
                      Wir verwenden Cookies
                    </h3>
                    <p className="text-xs text-[#6e6e73] mt-0.5">
                      Für eine bessere Benutzererfahrung
                    </p>
                  </div>
                </div>
                <button
                  onClick={acceptEssential}
                  className="text-[#6e6e73] hover:text-[#1d1d1f] transition-colors p-1"
                >
                  <X size={18} />
                </button>
              </div>

              {/* Description */}
              <p className="text-sm text-[#6e6e73] leading-relaxed mb-5">
                Wir nutzen Cookies, um Ihnen die bestmögliche Nutzung unserer Website zu
                ermöglichen. Einige sind notwendig, damit die Website funktioniert, andere helfen
                uns, die Website zu verbessern.{" "}
                <button
                  onClick={() => {
                    setVisible(false);
                    navigate("/cookies");
                  }}
                  className="text-[#4a7c59] hover:underline font-medium inline-flex items-center gap-0.5"
                >
                  Mehr erfahren
                  <ChevronRight size={12} />
                </button>
              </p>

              {/* Buttons */}
              <div className="flex flex-col sm:flex-row gap-3">
                <button
                  onClick={acceptAll}
                  className="flex-1 bg-[#4a7c59] hover:bg-[#3d6a4a] text-white text-sm font-medium py-3 px-6 rounded-xl transition-all duration-300 hover:shadow-lg"
                >
                  Alle akzeptieren
                </button>
                <button
                  onClick={acceptEssential}
                  className="flex-1 bg-[#f5f5f7] hover:bg-[#e5e5e5] text-[#1d1d1f] text-sm font-medium py-3 px-6 rounded-xl transition-all duration-300"
                >
                  Nur Notwendige
                </button>
                <button
                  onClick={() => {
                    setVisible(false);
                    navigate("/datenschutz");
                  }}
                  className="text-sm text-[#6e6e73] hover:text-[#1d1d1f] font-medium py-3 px-4 transition-colors"
                >
                  Datenschutz
                </button>
              </div>
            </div>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default CookieBanner;
